const cities = [
  { name: "Edmond", zips: "73003, 73012, 73013, 73025, 73034, 73083" },
  { name: "Oklahoma City", zips: "73102, 73103, 73104, 73105, 73106, 73107, 73108, 73109, 73110, 73111, 73112, 73114, 73115, 73116, 73117, 73118, 73119, 73120, 73121, 73122, 73127, 73128, 73131, 73132, 73134, 73135, 73139, 73142, 73145, 73149, 73159, 73160, 73162, 73169, 73170, 73173" },
  { name: "Yukon", zips: "73085, 73099" },
  { name: "Piedmont", zips: "73078" },
  { name: "Guthrie", zips: "73044" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your home, office, or UCO campus in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function EdmondLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Edmond &amp; North Oklahoma City Metro
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Edmond is one of Oklahoma's fastest-growing and most affluent suburbs, consistently ranked among the best places to live in the United States. Located just 15 miles north of Oklahoma City, Edmond combines small-town charm with big-city amenities, and its residents travel internationally at rates well above the state average.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              <strong className="text-[#1A365D]">Oak Tree &amp; Coffee Creek:</strong> These upscale residential neighborhoods are home to executives, physicians, attorneys, and entrepreneurs who travel frequently for both business and pleasure. European river cruises, Caribbean vacations, and international business trips to Tokyo and London are common. Many residents have family passports that expire simultaneously, requiring coordination of multiple renewals on tight timelines.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              <strong className="text-[#1A365D]">University of Central Oklahoma:</strong> UCO is a major public university with 16,000+ students and strong international programs. UCO's business and education colleges send students on study abroad programs to Germany, Spain, and Southeast Asia. The university also attracts international faculty who travel frequently and international students who may need passport guidance for domestic travel documents.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              <strong className="text-[#1A365D]">Spring Hollow &amp; Deer Creek:</strong> These established northern Edmond neighborhoods have a high concentration of families with school-age children. Family vacation planning drives the majority of passport demand — European river cruises in summer, Caribbean resorts during spring break, and Mexican beach vacations are the most common destinations.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              <strong className="text-[#1A365D]">Guthrie, Piedmont &amp; Yukon:</strong> These neighboring communities rely on Edmond and OKC for passport services. Many residents work in Edmond or OKC and need passport services that fit their commuting schedules. Our mail-based renewal service is ideal for residents who cannot take time off work for multiple facility visits.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Edmond, OK</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving all of North Oklahoma City metro remotely</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Remote service — serving Edmond, OKC, Yukon, Piedmont &amp; Guthrie
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Ship your documents overnight from anywhere in the north OKC metro</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, ship your documents with our <strong className="text-white">prepaid overnight label</strong> from any UPS or FedEx location in Edmond. Most clients never need to visit an office — just start online, ship overnight, and we handle the rest.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono hidden sm:inline truncate ml-2 max-w-[160px]">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in the north OKC metro area — start online, ship overnight, and we handle the rest. No need to drive to Oklahoma City for regional agency appointments.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Oklahoma City", href: "/cities/oklahoma-city" },
                    { name: "Norman", href: "/cities/norman" },
                    { name: "Tulsa", href: "/cities/tulsa" },
                    { name: "Broken Arrow", href: "/cities/broken-arrow" },
                    { name: "Moore", href: "/states/oklahoma" },
                    { name: "Stillwater", href: "/states/oklahoma" },
                  ].map((link) => (
                    <a
                      key={link.href + link.name}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Edmond Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}